import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import AdminLogin from "./pages/AdminLogin";
import IcmPage from './pages/IcmPage';
import AdminDashboard from "./pages/AdminDashboard";
import BillboardCreator from "./pages/BillboardCreator";
import BillboardView from "./pages/BillboardView";
import FloorPlanView from "./pages/FloorPlanView";
import HomePage from "./pages/HomePage";
import PokerTourPage from "./pages/PokerTourPage";
import PokerRoomPage from "./pages/PokerRoomPage";
import { NewsListPage, NewsDetailPage } from "./pages/NewsPage";
import { SeriesListPage, SeriesDetailPage, SeriesBillboardPage } from "./pages/SeriesPage";
import WatchPage from "./pages/WatchPage";
import AboutPage from "./pages/AboutPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Admin wrapper with auth state
const AdminWrapper = () => {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('rdpt_admin_user');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (parsed?.token) {
          axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${parsed.token}` } })
            .then(res => setUser({ ...parsed, ...res.data }))
            .catch(() => { localStorage.removeItem('rdpt_admin_user'); })
            .finally(() => setChecking(false));
          return;
        }
      } catch (e) { console.warn('Stored admin session unreadable, ignoring:', e.message); }
    }
    setChecking(false);
  }, []);

  const handleLogin = (data) => {
    setUser(data);
    localStorage.setItem('rdpt_admin_user', JSON.stringify(data));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('rdpt_admin_user');
  };

  if (checking) {
    return <div className="min-h-screen bg-background-base flex items-center justify-center">
      <span className="text-white/50 font-heading">Loading...</span>
    </div>;
  }

  return (
    <Routes>
      <Route path="/login" element={
        user ? <Navigate to="/admin" replace /> : <AdminLogin onLogin={handleLogin} />
      } />
      <Route path="/billboard" element={
        user ? <BillboardCreator user={user} /> : <Navigate to="/admin/login" replace />
      } />
      <Route path="/icm" element={
        user ? <IcmPage user={user} /> : <Navigate to="/admin/login" replace />
      } />
      <Route path="/*" element={
        user ? <AdminDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/admin/login" replace />
      } />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/series" element={<SeriesListPage />} />
        <Route path="/series/:slug" element={<SeriesDetailPage />} />
        <Route path="/series/:slug/board" element={<SeriesBillboardPage />} />
        <Route path="/poker-room" element={<PokerRoomPage />} />
        <Route path="/poker-tour" element={<PokerTourPage />} />
        <Route path="/news" element={<NewsListPage />} />
        <Route path="/news/:slug" element={<NewsDetailPage />} />
        <Route path="/watch" element={<WatchPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/billboard/view" element={<BillboardView />} />
        <Route path="/billboard/floor" element={<FloorPlanView />} />
        <Route path="/admin/*" element={<AdminWrapper />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
